// init __DPM_Federation__ object

// Global DevExtreme license key
// https://supportcenter.devexpress.com/ticket/details/t1270013/devextreme-angular-license-not-found-in-application-with-module-federation-microfrontends
const licenseKey =
  "ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogImNkM2VlNWI4LTQwZjAtNGRhYi04MGM1LTVmMzM5ZDU1NDY1NiIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjUxCn0=.gVXDdH7aOyhn/5s79kqTNoQLqNyreUF1Ju1IISBk8vQ4w12YVmh48aAIZ3nvQdBt14EfRIrpvaIw5FnEHuLEi+UbskOXwnPbEvr1h52+PUQs69AbDU5rAHVNsGm0daxzjEEKLw==";
window.DevExpress = window.DevExpress || {};
window.DevExpress.config = {
  licenseKey,
};

if (!globalThis.__DPM_Federation__) {
    globalThis.__DPM_Federation__ = {
        configuration: undefined,
        apiConfig: undefined,
        languageConfig: undefined,
        oidcConfig: undefined,

        oidcManager: undefined,
        languageResources: undefined,

        eventHub: undefined,
    }
}

// load import local import map (which will be provided using release pipeline for specific environment)
let apiConfigLoader = fetch(window.location.origin + '/apiConfig.json')
    .then((response) => { return response.json() })
    .then((res) => {
        globalThis.__DPM_Federation__.apiConfig = res;
        return res
    });

let languageConfigLoader = fetch(
  window.location.origin + "/languageConfig.json",
)
  .then((response) => response.json())
  .then((res) => {
    globalThis.__DPM_Federation__.languageConfig = res;
    return res;
  })
  .catch(() => {
    console.warn("languageConfig.json not found, using default configuration");
    return null;
  });

function initApplication() {

    const configurationOrigin = globalThis.__DPM_Federation__.apiConfig.importMaps ?? (window.location.origin + '/pidpm-shell-importmap.json');

    fetch(configurationOrigin)
        .then(response => response.json())
        .then(function (data) {
            globalThis.__DPM_Federation__.configuration = data;
            // first replace import map entries with overrides from localStorage
            if (globalThis.__DPM_Federation__.configuration.imports != undefined) {
                for (const [imKey, imValue] of Object.entries((globalThis.__DPM_Federation__.configuration.imports))) {
                    console.log(`Checking import map key: ${imKey} with value: ${imValue}`);
                    const lsItem = window.localStorage.getItem(imKey);
                    if (lsItem != undefined) {
                        console.log(`Found localStorage item for key: ${imKey}`);
                        const lsItemData = JSON.parse(lsItem)
                        if (lsItemData.active && lsItemData.active == true) {
                            globalThis.__DPM_Federation__.configuration.imports[imKey] = lsItemData.overrideUrl
                        }
                    }
                }
            }

            // then load Shell main entry
            const script = document.createElement('script');
            script.src = window.location.origin + '/main.js'
            script.onerror = (event, source, lineno, colno, err) => {
                console.log(event, source, lineno, colno, err)
            }
            document.head.appendChild(script);
        })

}

function loadConfigurations() {
    Promise.all([apiConfigLoader, languageConfigLoader]).then((results) => {
        window.apiConfig = results[0];
        window.languageConfig = results[1]; 
        initApplication()

    }).catch(err => console.log(err))
}

loadConfigurations();

export {
    initApplication,
    loadConfigurations
}